import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { EffectsModule } from '@ngrx/effects';

import { DropdownModule } from '../../../lib/dropdown/dropdown.module';
import { NumpadModule } from '../../../lib/numpad/numpad.module';
import BetslipBaseModule from '../../base/betslip-base.module';
import { BetslipDigitalCommonModule } from '../common/digital-module';
import { InfoMessageContainerComponent } from '../info-messages/info-message-container/info-message-container.component';
import { LinearBetslipModule } from '../linear/linear-betslip-module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import PickOddsModule from '../picks/pick-odds.module';
import BetslipDigitalStakeModule from '../stake/betslip-digital-stake.module';
import BetslipDigitalSummaryModule from '../summary/betslip-digital-summary.module';
import BetslipDigitalValidationModule from '../validation/betslip-digital-validation.module';
import SystemBetBarLinearComponent from './components/system-bet-bar/system-bet-bar-linear.component';
import SystemBetBarComponent from './components/system-bet-bar/system-bet-bar.component';
import SystemBetLinearComponent from './components/system-bet-linear.component';
import SystemBetPickComponent from './components/system-bet-pick.component';
import SystemBetTypeContainerComponent from './components/system-bet-types/system-bet-type-container.component';
import SystemBetTypesListComponent from './components/system-bet-types/system-bet-types-list.component';
import SystemBetComponent from './components/system-bet.component';
import DigitalSystemBetEffects from './effects/digital-system-bet-effects';
import StakeEffects from './effects/stake-effects';
import SystemBetLinearEffects from './effects/system-bet-linear-effects';
import SystemBetStateStorageService from './services/system-bet-state-storage.service';
import SystemBetsService from './services/system-bets.service';
import SystemFactoryService from './services/system-factory.service';
import SystemBetTypesCalculatorService from './services/types/system-bet-types-calculator.service';
import SystemBetTypesPopUpInfoService from './services/types/system-bet-types-popup-info.service';
import SystemBetTypesService from './services/types/system-bet-types.service';

@NgModule({
    providers: [
        SystemBetsService,
        SystemFactoryService,
        SystemBetStateStorageService,
        SystemBetTypesService,
        SystemBetTypesCalculatorService,
        SystemBetTypesPopUpInfoService,
    ],
    declarations: [
        SystemBetComponent,
        SystemBetPickComponent,
        SystemBetBarComponent,
        SystemBetLinearComponent,
        SystemBetBarLinearComponent,
        SystemBetTypesListComponent,
        SystemBetTypeContainerComponent,
    ],
    exports: [SystemBetComponent, SystemBetLinearComponent],
    imports: [
        CommonModule,
        DropdownModule,
        BetslipBaseModule,
        BetslipDigitalPicksModule,
        BetslipDigitalValidationModule,
        BetslipDigitalCommonModule,
        EffectsModule.forFeature([DigitalSystemBetEffects, StakeEffects, SystemBetLinearEffects]),
        PickOddsModule,
        NumpadModule,
        AutomationModule,
        BetslipDigitalStakeModule,
        BetslipDigitalSummaryModule,
        LinearBetslipModule,
        InfoMessageContainerComponent,
    ],
})
export default class BetslipDigitalSystemBetModule {}
